import React from 'react';

import { Settings } from 'components';

export const TechOperatorSettingsPage: React.FC = () => <Settings />;
